import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import MenuItem from "@material-ui/core/MenuItem";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronRight} from "@fortawesome/free-solid-svg-icons";
import {UserAccountContext} from "../../../../contexts/userAccount";

import "./style.scss";

export default class PlacebarMenuItems extends PureComponent {
  // noinspection JSUnusedGlobalSymbols
  static contextType = UserAccountContext;

  render() {
    let {newPath, itemLabel} = this.props;
    return (
      <div className="places">
        {this.renderMenuItems()}
        {this.context.user.permissions.edit.resources &&
        this.renderLink(newPath, "new", `New ${itemLabel}`, true)}
      </div>
    );
  }

  renderMenuItems() {
    return this.props.items.map(item => this.renderLink(`/map/${item.getPath()}`, item._id, item.name));
  }

  renderLink(linkPath, key, label, mobileOnly = false) {
    let className = mobileOnly ? "mobileAddItem" : "";
    return (
      <Link to={linkPath} onClick={this.props.onClick} key={key}>
        <MenuItem className={`placeListItem ${className} ${key}`}>
          <div className="placeListItemHead">{label}</div>
          <FontAwesomeIcon icon={faChevronRight} className="chevron"/>
        </MenuItem>
      </Link>
    );
  }
}

PlacebarMenuItems.propTypes = {
  onClick: PropTypes.func.isRequired,
  itemLabel: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  newPath: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/Placebar/components/PlacebarMenuItems/index.jsx